import { SimpleOption } from "./SimpleListbox";

/**
 * Narrows a list of options to what someone has typed, best match first.
 *
 * Ranking matters more than it looks. Someone typing "NC" means North Carolina, so a code
 * match has to beat a name match -- otherwise Nebraska and Nevada, whose names start with
 * "N", would crowd it out. Within each kind an exact match beats a prefix, and a prefix beats
 * a match in the middle of the word, so "in" offers Indiana before North Carolina even though
 * both contain it.
 *
 * An empty query returns everything, so the list reads as a plain dropdown until it is used.
 */
export function filterOptions(options: SimpleOption[], query: string): SimpleOption[] {
	const search = query.trim().toLowerCase();
	if (!search) return options;

	const rank = (option: SimpleOption): number => {
		const code = option.code?.toLowerCase() ?? "";
		const label = option.label?.toLowerCase() ?? "";

		if (code && code === search) return 0;
		if (label === search) return 1;
		if (code && code.startsWith(search)) return 2;
		if (label.startsWith(search)) return 3;
		if (label.includes(search)) return 4;
		return -1;
	};

	return options
		.map((option, index) => ({ option, index, rank: rank(option) }))
		.filter((entry) => entry.rank >= 0)
		.sort((a, b) => a.rank - b.rank || a.index - b.index)
		.map((entry) => entry.option);
}
